export default __webpack_public_path__ + "static/media/enroll-letter.3b013561.svg";